import { Stack } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import React from "react";
import type { PhoneType } from "../../../../clients/graphqlTypes.js";
import { TextField } from "../../../commons/form-fields/TextField.js";
import {
  ONBOARDING_FIELDS_SX,
  OnboardingAddressFields,
  OnboardingPhoneRow,
  FormSection,
} from "./OnboardingFormParts.js";

interface Props {
  /** The type of the phone the organisation already has. */
  storedPhoneType?: PhoneType;
  disabled?: boolean;
}

/**
 * The fields of "Your property": the optional property name, the address of the
 * property and the contact details. The contact email is the one required
 * field; there is no website lookup, logo or tax section.
 */
export const OnboardingPropertyFormFields = ({
  storedPhoneType,
  disabled = false,
}: Props) => {
  const { t } = useTranslate(["Global", "OrganisationProfile"]);

  return (
    <Stack spacing="40px" sx={ONBOARDING_FIELDS_SX}>
      <TextField
        name="propertyName"
        label={t("Property name", { ns: "OrganisationProfile" })}
        // Shown while the field is focused, as the label then sits above.
        placeholder={t("e.g. “Home” or “Holiday house”", {
          ns: "OrganisationProfile",
        })}
        fullWidth
      />
      <FormSection
        title={t("Property address", { ns: "OrganisationProfile" })}
        subline={t("Where the work takes place", { ns: "OrganisationProfile" })}
      >
        <OnboardingAddressFields disabled={disabled} />
      </FormSection>
      <FormSection
        title={t("Contact", { ns: "Global" })}
        subline={t("How your craftsman reaches you", {
          ns: "OrganisationProfile",
        })}
        requiredNote
      >
        <TextField
          name="email"
          type="email"
          required
          label={t("Contact email", { ns: "OrganisationProfile" })}
          fullWidth
        />
        <OnboardingPhoneRow
          phoneLabel={t("Phone number", { ns: "OrganisationProfile" })}
          storedPhoneType={storedPhoneType}
          disabled={disabled}
        />
      </FormSection>
    </Stack>
  );
};
